import styled from 'styled-components';
export const ImagesSkeleton = styled.div`
  display: grid;
  grid-template-columns: minmax(500px, 820px) minmax(200px, 400px);
  gap: 0 20px;
  width: 100vw;
  background-color: ${({ theme }) => theme.palette.white};
  justify-content: center;
  padding: 40px;
  margin-top: 20px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 10px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    grid-template-columns: minmax(320px, 760px);
    grid-template-rows: 158px;
    gap: 0;
    margin: 0;
    padding: 0;
  }
`;

export const SummarySkeleton = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  padding: 70px 0 40px 40px;
  border-radius: 2px;
  box-shadow: 0 10px 20px 0 ${({ theme }) => theme.palette.veryLightBlack};
  z-index: 2;
  top: -80px;
  position: relative;
  margin-bottom: -60px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    padding: 15px;
    top: 0;
    margin-bottom: 20px;
  }
`;

export const OpportunitySkeleton = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  padding: 48px 40px;
  border-radius: 2px;
  box-shadow: 0 10px 20px 0 ${({ theme }) => theme.palette.veryLightBlack};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    padding: 60px 15px;
    display: flex;
    justify-content: center;
  }
`;

export const OpportunitySkeletonContent = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(100px, 261px));
  gap: 0 20px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    grid-template-columns: repeat(2, 137px);
    gap: 20px 15px;
  }
`;

export const AmenitySkeleton = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  padding: 48px 40px;
  border-radius: 2px;
  box-shadow: 0 10px 20px 0 ${({ theme }) => theme.palette.veryLightBlack};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    padding: 60px 15px;
    display: flex;
    justify-content: center;
  }
`;

export const AmenitySkeletonContent = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(60px, 158px));
  gap: 0 30px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    grid-template-columns: repeat(2, 132px);
    gap: 30px 25px;
  }
`;

export const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
`;

export const SkeletonContentWrapper = styled.div`
  max-width: 1240px;
  margin: 0 auto;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0 20px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    padding: 0;
  }
`;
export const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 40px 38px 40px 40px;
  border-radius: 8px;
  color: ${({ theme }) => theme.palette.darkGrey};
  box-shadow: 0 10px 20px 0 rgba(58, 58, 58, 0.1);
  position: relative;
  background-color: ${({ theme }) => theme.palette.white};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    margin: 20px 0;
    padding: 23px 15px 20px 15px;
  }
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: bold;

  color: ${({ theme }) => theme.palette.darkGrey};
`;
